import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { queryClient } from '@/utils/queryClient'
import { QueryClientProvider } from '@tanstack/react-query'
import dayjs from 'dayjs'
import 'dayjs/locale/ko'
import '@/styles/reset.css'
import 'swiper/css'
import 'swiper/css/free-mode'
import { bootstrapApplication } from '@/bootstrap'

dayjs.locale('ko')

const renderApplication = (): void => {
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  )

  reportWebVitals()
}

bootstrapApplication(renderApplication).catch(() => undefined)
